import React from 'react'
import Header from './Header'
import CreateACardFooter from './CreateACardFooter'
import Footer from '../Footer'
import { Container } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { rootStyles } from './themeStyles'

const useStyles = makeStyles((theme) => ({ ...rootStyles }))

const Layout = ({
    children,
    baseUrl,
    faqUrl,
    brandLogoUrl,
    footerContent,
    useCreateACardFooter = true,
}) => {
    const classes = useStyles()

    return (
        <>
            <Header logoUrl={baseUrl} logoImage={brandLogoUrl} />
            <Container className={classes.root} maxWidth="lg">
                {children}
            </Container>
            {useCreateACardFooter ? (
                <CreateACardFooter faqUrl={faqUrl} content={footerContent} />
            ) : (
                <Footer baseUrl={baseUrl} />
            )}
        </>
    )
}

export default Layout
